module.exports = __webpack_public_path__ + "img/r3.7c48d389.png";